import { capitalize } from './capitalize';

/**
 * Formats a category key or store label while preserving localized text and punctuation.
 * 'NEWS_AND_MAGAZINES' => 'News & Magazines'
 *
 * @param {string} category
 * @returns {string} Formatted category label
 */
export const formatCategory = (category: string): string => capitalize(category.replaceAll('_', ' ').replace(/\band\b/gi, '&'), true);
